import { useWikidailyStore } from "./store";
import type { FoundArticle } from "./types";

export const selectFoundTargetCount = (
  state: ReturnType<typeof useWikidailyStore.getState>,
) =>
  state.gameState?.found_articles?.filter((fa: FoundArticle) => fa.is_target)
    .length ?? 0;

export const selectTargetCount = (
  state: ReturnType<typeof useWikidailyStore.getState>,
) => state.gameState?.challenge?.target_articles?.length ?? 0;

// isHost needs current player ID from app store, so it's a factory function
export const createSelectIsHost =
  (currentPlayerId: string) =>
  (state: ReturnType<typeof useWikidailyStore.getState>) => {
    const hostId = state.lobbyState?.host_id;
    return currentPlayerId === hostId;
  };
